import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/account/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/account/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/account/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/account/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/account/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/account/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/account/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/account/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/account/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/account/role/update',
    method: 'post',
    data: data
  })
}

export function updateIsStaff(id, params) {
  return request({
    url: '/account/updateStaffStatus/' + id,
    method: 'post',
    params: params
  })
}

export function getUserInfo(id) {
  return request({
    url: '/account/' + id,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js